import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBookOpen } = FiIcons;

function AuthShell({
  kicker,
  title,
  subtitle,
  stepLabel,
  children
}) {
  return (
    <div className="app-container">
      <main className="page-shell">
        <section className="mx-auto max-w-lg overflow-hidden rounded-[22px] border border-[#e3e4de] bg-white shadow-[0_18px_50px_rgba(37,48,45,0.07)]">
          <header className="border-b border-[#e3e4de] px-6 py-6 sm:px-8">
            <div className="flex items-center justify-between gap-4">
              <span className="brand">
                <span className="brand-mark">
                  <SafeIcon icon={FiBookOpen} />
                </span>
                <span>Quantix</span>
              </span>
              {stepLabel ? (
                <span className="text-xs font-semibold text-[#6c7773]">
                  {stepLabel}
                </span>
              ) : null}
            </div>
            {kicker ? <span className="eyebrow mt-5 block">{kicker}</span> : null}
            <h1 className="mt-3 font-['Manrope'] text-3xl font-bold tracking-[-0.04em] text-[#24302d]">
              {title}
            </h1>
            {subtitle ? (
              <p className="mt-3 text-sm leading-6 text-[#6c7773]">
                {subtitle}
              </p>
            ) : null}
          </header>
          <div className="px-6 py-8 sm:px-8">
            {children}
          </div>
        </section>
      </main>
    </div>
  );
}

export default AuthShell;
